import { forEach, map as _map } from 'lodash-es';
import { Injectable } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
    AggregateService,
    ShellDomainProvider,
    SqlQueryBuilderService,
    StorageDataService,
    UtilityService
} from '../../shared/standalone-packages/ecap3/core';

@Injectable()
export class DocumentUploadService {
    constructor(
        private sqlQueryBuilderService: SqlQueryBuilderService,
        private storageDataService: StorageDataService,
        private utilityService: UtilityService,
        private aggregateService: AggregateService
    ) {}

    uploadDocument(selectedFiles, tag: string, connectionObj?: any, accessModifier?: any) {
        const resultAggregate = [];
        const aggregatePayload = [];

        forEach(selectedFiles, file => {
            const ItemId = this.utilityService.getNewGuid(),
                MetaData = file,
                Name = file.name,
                ParentDirectoryId = null,
                // Tags = [tag || 'Debug'];
                Tags = [tag];

            aggregatePayload.push(
                this.aggregateService.aggregatePresignedModel(
                    JSON.stringify(
                        this.storageDataService.generatePSU(ItemId, Name, ParentDirectoryId, Tags, accessModifier)
                    )
                )
            );
        });

        return this.aggregateService
            .aggregateExecute(aggregatePayload)
            .pipe(
                switchMap((response: any) => {
                    if (response.FailedCallIndex > -1) {
                        return of(response);
                    }

                    const firstResponseList = response.HttpAggregateCallResults;
                    firstResponseList.forEach(responseItem => {
                        const firstResponse = JSON.parse(responseItem.Response);
                        if (ShellDomainProvider['api'].IsStaging) {
                            firstResponse.UploadUrl = firstResponse.UploadUrl.replace('http:', 'https:');
                        }

                        resultAggregate.push(firstResponse);
                    });

                    const callArray = [];

                    forEach(resultAggregate, (item, key) => {
                        callArray.push(this.storageDataService.uploadPresignedFile(item.UploadUrl, selectedFiles[key]));
                    });

                    return forkJoin(callArray);
                })
            )
            .pipe(
                map((response: any) => {
                    const fileResponse = {
                        resultAggregate: resultAggregate,
                        FileIds: resultAggregate.length > 0 ? _map(resultAggregate, 'FileId') : [],
                        fileUploaded: resultAggregate.length > 0
                    };

                    if (connectionObj) {
                        const connectionCallList = this.getFileConnections(resultAggregate, connectionObj);
                        this.aggregateService.aggregateExecute(connectionCallList).subscribe(data => {
                            return data;
                        });
                    }

                    return fileResponse;
                })
            );
    }

    getFileConnections(presignedData, connectionObj) {
        const connectionCommand = [];
        forEach(presignedData, item => {
            const filterQuery = this.sqlQueryBuilderService.prepareConnectModel(
                this.utilityService.getNewGuid(),
                connectionObj['ParentEntityName'],
                connectionObj['ParentEntityID'],
                'File',
                item.FileId,
                connectionObj['Tag'],
                null
            );

            connectionCommand.push(this.aggregateService.aggregateConnectModel(filterQuery));
        });

        return connectionCommand;
    }
}
